import { configureStore } from "@reduxjs/toolkit";
import policySlice from "./policy";
import paymentSlice from "./payment";
import medicalAssessmentReducer from './medicalAssessmentSlice';

export const store = configureStore({
  reducer: { policySlice ,paymentSlice, medicalAssessment: medicalAssessmentReducer},
});
